import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';


class DeviceRenderer extends Component {
  render() {
    const { data } = this.props;

    if (!data || !data.user_agent || !data.user_agent.os) {
      return null;
    }
    let icon = null;

    if (data.user_agent.os.name === 'Mac') {
      icon = 'apple';
    } else if (data.user_agent.os.name === 'Windows') {
      icon = 'windows';
    } else if (data.user_agent.os.name === 'Linux') {
      icon = 'linux';
    }
    const sub = [];
    if (data.user_agent.os.name) {
      sub.push(data.user_agent.os.name);
      if (data.user_agent.os.name) {
        sub.push(data.user_agent.os.version);
      }
    }
    
    const expl = [];
    if (data.user_agent.device) {
      const { brand, type } = data.user_agent.device;
      if (brand) {
        expl.push(brand);
        if (type) {
          expl.push(type);
        }
      }
    }
  
    return (
      <span>{(icon !== null ? <Fa name={icon} /> : '')} {sub.join(' ')} {(expl.length > 0 ? `(${expl.join(' ')})` : '')}</span>
    );
  }
}

DeviceRenderer.propTypes = {
  data: PropTypes.shape({
    user_agent: PropTypes.shape({
      device: PropTypes.shape({
        brand: PropTypes.string,
        type: PropTypes.string,
      }),
      os: PropTypes.shape({
        name: PropTypes.string,
        version: PropTypes.string,
      }),
    }),
  }),
};
DeviceRenderer.defaultProps = {
  data: null,
};

export default DeviceRenderer;
